import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ApiRequestService } from '@prekog/common-ui';
import { BlogEnum } from '../shared/blog.enum';
import { Material } from '../shared/material.model';
import { ProductsResponse } from '../shared/products.response';
import { PublicationService } from '../shared/publication.service';
import { Blog } from './blog';
import { GetPublishedBlogsRequest } from './getpublishedblogsrequest';
import { GetPublishedBlogsResponse } from './getpublishedblogsresponse';

@Component({
    selector: 'pf-blog-slideshow',
    templateUrl: './blog-slideshow.component.html',
    styleUrls: ['./blog-slideshow.component.scss'],
    standalone: true,
    imports: [MatIconModule, RouterModule],
    animations: [trigger('fade', [state('void', style({ opacity: 0.3 })), transition('void => *', [animate('0.5s ease-out')])])]
})
export class BlogSlideshowComponent implements OnInit {
    alive = false;

    bannerActual: Blog[] = [];

    bannerActualMobile?: Blog = {};

    bannerActualMobiles = '';

    bannerCrumbs: Blog[] = [];

    @Input() bannersBlogUrl = '';

    configuratorBaseUrl = '';
    downloadFileUrl = '';
    getProductsUrl = '/order/get-products';
    getPublishedBlogsUrl = '/websiteconfigurator/get-published-blogs';

    hasNotAnimation = false;

    imagesLoaded = 0;

    imageToShow = '';

    index = 0;

    @Input() isBannerThumb = false;

    loading = true;

    materialsActual: Material[] = [];

    materialsAvailable: Material[] = [];

    materialsMobileActual?: Material = {};

    numberOfImages = 0;

    orderBackenUrl = '';
    thumbirls: string[] = [];

    thumbNumImages = this.thumbirls.length;

    constructor(
        private _publicationService: PublicationService,
        private _apiRequestService: ApiRequestService,
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string,
        @Inject('DOWNLOAD_FILE_URL') private _downloadFileUrl: string,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string
    ) {
        this.orderBackenUrl = _orderBackendUrl;
        this.downloadFileUrl = _downloadFileUrl;
        this.configuratorBaseUrl = _configuratorBaseUrl;
    }

    ngOnInit() {
        if (this.isBannerThumb === true) {
            const getPublishedBlogRequest: GetPublishedBlogsRequest = {
                type: BlogEnum.NEWS
            };
            this._apiRequestService
                .sendRequest<
                    {},
                    GetPublishedBlogsResponse
                >(this.configuratorBaseUrl, getPublishedBlogRequest, true, this.getPublishedBlogsUrl)
                .subscribe((getPublishedBlogsResponse: GetPublishedBlogsResponse) => {
                    this.bannerCrumbs = getPublishedBlogsResponse?.publishedBlogList!;
                    this.bannerCrumbs.forEach((banner, index) => {
                        if (index < 3) {
                            this.numberOfImages++;
                            this.bannerActual.push(banner);
                        }
                        if (index === 0) {
                            this.bannerActualMobile = banner;
                        }
                    });
                });
        } else {
            this.materialsActual = [];
            this.materialsAvailable = [];
            this.materialsMobileActual = {};
            this.numberOfImages = 0;
            this.initializeProducts();
        }
    }

    showNextImage() {
        if (this.isBannerThumb === true) {
            if (!this.bannerActual.includes(this.bannerCrumbs[this.bannerCrumbs.length - 1])) {
                this.bannerActual = [];
                const indexx = this.numberOfImages + 3;
                this.bannerCrumbs.forEach((banner, index) => {
                    if (index >= this.numberOfImages && index < indexx) {
                        this.numberOfImages++;
                        this.bannerActual.push(banner);
                    }
                });
            }
        } else {
            if (!this.materialsActual.includes(this.materialsAvailable[this.materialsAvailable.length - 1])) {
                this.materialsActual = [];
                const indexx = this.numberOfImages + 3;
                this.materialsAvailable.forEach((material, index) => {
                    if (index >= this.numberOfImages && index < indexx) {
                        this.numberOfImages++;
                        this.materialsActual.push(material);
                    }
                });
            }
        }
    }

    showPreviousImage() {
        if (this.isBannerThumb === true) {
            if (
                !this.bannerActual.includes(this.bannerCrumbs[0]) &&
                !this.bannerActual.includes(this.bannerCrumbs[this.bannerCrumbs.length - 1])
            ) {
                if (this.numberOfImages >= 3) {
                    const indexx = this.numberOfImages - 3 - this.bannerActual.length;
                    this.bannerActual = [];

                    this.bannerCrumbs.forEach((banner, index) => {
                        if (index < this.numberOfImages && index >= indexx) {
                            this.bannerActual.push(banner);
                            this.numberOfImages--;
                        }
                    });
                }
            } else if (this.bannerActual.includes(this.bannerCrumbs[this.bannerCrumbs.length - 1]) && this.bannerCrumbs.length > 3) {
                const number = this.bannerActual.length;
                const arrayLength = this.bannerCrumbs.length - number;
                this.numberOfImages = this.numberOfImages - number;
                this.bannerActual = [];

                this.bannerCrumbs.forEach((banner, index) => {
                    if (index < arrayLength && index >= arrayLength - 3) {
                        this.bannerActual.push(banner);
                    }
                });
            }
        } else {
            if (
                !this.materialsActual.includes(this.materialsAvailable[0]) &&
                !this.materialsActual.includes(this.materialsAvailable[this.materialsAvailable.length - 1])
            ) {
                if (this.numberOfImages >= 3) {
                    const indexx = this.numberOfImages - 3 - this.materialsActual.length;
                    this.materialsActual = [];

                    this.materialsAvailable.forEach((material, index) => {
                        if (index < this.numberOfImages && index >= indexx) {
                            this.materialsActual.push(material);
                            this.numberOfImages--;
                        }
                    });
                }
            } else if (
                this.materialsActual.includes(this.materialsAvailable[this.materialsAvailable.length - 1]) &&
                this.materialsAvailable.length > 3
            ) {
                const number = this.materialsActual.length;
                const arrayLength = this.materialsAvailable.length - number;
                this.numberOfImages = this.numberOfImages - number;
                this.materialsActual = [];

                this.materialsAvailable.forEach((material, index) => {
                    if (index < arrayLength && index >= arrayLength - 3) {
                        this.materialsActual.push(material);
                    }
                });
            }
        }
    }

    showNextImageMobile() {
        if (this.isBannerThumb === true) {
            if (this.index < this.bannerCrumbs.length - 1) {
                this.index++;
                this.bannerActualMobile = this.bannerCrumbs[this.index];
            }
        } else {
            if (this.index < this.materialsAvailable.length - 1) {
                this.index++;
                this.materialsMobileActual = this.materialsAvailable[this.index];
            }
        }
    }

    showPreviousImageMobile() {
        if (this.isBannerThumb === true) {
            if (this.index > 0) {
                this.index--;
                this.bannerActualMobile = this.bannerCrumbs[this.index];
            }
        } else {
            if (this.index > 0) {
                this.index--;
                this.materialsMobileActual = this.materialsAvailable[this.index];
            }
        }
    }

    addToCart(material: Material) {
        this._publicationService.addToCart(material);
    }

    initializeProducts() {
        this._apiRequestService.sendRequest(this.orderBackenUrl, {}, true, this.getProductsUrl).subscribe((productList) => {
            const productLists = productList as ProductsResponse;
            const materials = productLists.productList as Material[];
            materials.forEach((material) => {
                if (material.webshopPriceActive) {
                    material.oldPrice = material.originalPrice;
                    material.originalPrice = material.webshopPrice;
                }
                if (material.isAvailable) {
                    this.materialsAvailable.push(material);
                }
            });
            this.materialsAvailable.forEach((material, index) => {
                if (index < 3) {
                    this.numberOfImages++;
                    this.materialsActual.push(material);
                }
                if (index === 0) {
                    this.materialsMobileActual = material;
                }
            });
        });
    }
}
